class LogLogPanel {
  Save(msg) {
    if (!!window.log.ref) {
      window.log.ref();
    }
  }
}

export default LogLogPanel;
